import './HomeSlider.css';
import SliderBaner from './images/slider-img.jpg';  

function HomeSlider() {
return(
    <div className="home-slider" id='home'>
        <img src={SliderBaner} />
    </div>
)
}
export default HomeSlider